import React from 'react';
import { useLocation } from 'react-router-dom';
import ShareAccessCode from './components/ShareAccessCode';
import DownloadAccessCode from './components/DownloadAccessCode';

function AccessCode({ type = 'verify' }) {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const flag = queryParams.get('flag');

  return (
    <div>
      {flag === 'download' ? (
        <DownloadAccessCode />
      ) : (
        <ShareAccessCode />
      )}
    </div>
  );
}

export default AccessCode;
